export var WIDGET_ID='@shopgate/engage/product/RelationsSlider';